var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.424,
    height: 22.424,
    viewBox: "0 0 22.424 22.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19089",
    "data-name": "Path 19089",
    d: "M19.621,0H2.8A2.806,2.806,0,0,0,0,2.8V19.621a2.806,2.806,0,0,0,2.8,2.8H19.621a2.806,2.806,0,0,0,2.8-2.8V2.8A2.806,2.806,0,0,0,19.621,0Z",
    fill: "#1976d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19090",
    "data-name": "Path 19090",
    d: "M16.511,10.007h-3.5V7.2c0-.774.628-.7,1.4-.7h1.4V3h-2.8A4.2,4.2,0,0,0,8.8,7.2v2.8H6v3.5H8.8v7.708h4.2V13.511h2.1Z",
    transform: "translate(2.409 1.204)",
    fill: "#fafafa",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.211effb78b7cd8930f67aa1ee3f01862.svg";
export { ForwardRef as ReactComponent };